/**
 * @author PoornaChandu
 * @description 
 */
import React, { useEffect, useState } from 'react';
import { Tree,
  //  message,
    Checkbox } from 'antd';
import { DownOutlined } from '@ant-design/icons';
// import localStorage from '../../../utils/localStorage';
const { TreeNode } = Tree;
const HierarchyModal = (props) => {
  // const [optionList, setOptionList] = useState([]);
  // const [value, setValue] = useState([]);
  // const [autoExpandParent, setAutoExpandParent] = useState(true.valueOf);
  // const [expandedKeys, setExpandedKeys] = useState([]);
  // const [datasource, setDatasource] = useState([]);
  // const [checkedKeys, setCheckedKeys] = useState([]);
  const [treeData,setTreeData] = useState(props.treeData || []);
  const [checkedArray,setCheckedArray] = useState(props.selectedDevice || []);
  useEffect(() =>{
    if (
      checkedArray !== props.selectedDevice ||
      treeData !== props.treeData
    ) {
      setCheckedArray(props.selectedDevice);
      setTreeData(props.treeData);
    }
  },[props.selectedDevice,props.treeData]);
  // useEffect(() => {
  //   setCheckedArray(props.selectedDevice);
  // }, [props.selectedDevice]);
  // const renameProperty = (obj, oldName1, newName1, oldName2, newName2) => {
  //   if (obj && obj.children) {
  //     let children = obj.children.map((objChildren) => {
  //       return renameProperty(objChildren, oldName1, newName1, oldName2, newName2);
  //     });
  //     obj['children'] = children;
  //     obj[newName1] = obj[oldName1];
  //     delete obj[oldName1];
  //     obj[newName2] = obj[oldName2];
  //     delete obj[oldName2];
  //     return obj;
  //   } else {
  //     obj[newName1] = obj[oldName1];
  //     delete obj[oldName1];
  //     obj[newName2] = obj[oldName2];
  //     delete obj[oldName2];
  //     return obj;
  //   }
  // };
  // const getMenuHierarchyStructure = () => {
  //   JSON.parse(localStorage.get('modules'));
  //   if (treeData) {
  //     let final = treeData.map((userHierarchy) => {
  //       return renameProperty(userHierarchy, 'label', 'label', 'title', 'value');
  //     });
  //     return final;
  //   }
  // };
  // const getData = (item) => {
  //   let { Key } = props;
  //   if (Key === 'Asset') {
  //     if (item && item.Type === 'Site') {
  //       message.error('Cant select site');
  //     } else if (item.Type !== 'Device') {
  //       props.handleDropdownChange(item);
  //     } else {
  //       message.error('Please select valid input');
  //     }
  //   } else {
  //     props.handleDropdownChange(item);
  //     getParent(item.Name, item.ParentId, treeData);
  //   }
  // };
  // const getParent = (Name, ParentId, treeData) => {
  //   let firstLevelParent = {};
  //   let children = [];
  //   let secondLevelParent = [];
  //   for (let i = 0; i < treeData.length; i++) {
  //     const node = treeData[i];
  //     if (node.children) {
  //       if (node.children.some((item) => item.Id === ParentId)) {
  //         firstLevelParent = node;
  //         children = node.children;
  //         if (children) {
  //           for (let i = 0; i < children.length; i++) {
  //             const childNode = children[i];
  //             if (childNode.children && childNode.children.length > 0) {
  //               if (childNode.Id === ParentId) {
  //                 secondLevelParent = childNode;
  //               }
  //             }
  //           }
  //         }
  //         if (props.handleParentNode) {
  //           props.handleParentNode(firstLevelParent, secondLevelParent);
  //         }
  //       } else if (getParent(Name, ParentId, node.children)) {
  //         getParent(Name, ParentId, node.children);
  //       }
  //     }
  //   }
  //   return firstLevelParent;
  // };
  // const checkboxOnChange = (value) => {
  //   let updatedCheckedArray = checkedArray.includes(value)
  //     ? checkedArray.some((e) => e !== value)
  //     : [...checkedArray, value];
  //   setCheckedArray(updatedCheckedArray);
  //   props.handleDropdownChange(updatedCheckedArray);
  // };
const getTextOnChange = (itemData) => {
  let { Code } = itemData;
  let { selectedDevice, handleDropdownChange } = props; 
  const itemExists = selectedDevice.some((e) => e === Code); 
  let updatedArray;
  if (itemExists) {
      updatedArray = selectedDevice.filter((val) => val !== Code);
  } else {
      updatedArray = [...selectedDevice, Code]; 
  }
  handleDropdownChange(updatedArray); 
};
const renderTreeNodes = (data) => {
  const {selectedOption } = props;
  return data.map((item) => {
    const hasChildren = item.children && item.children.length > 0;
    const isMatchingType =
      (item.Type === 'Asset' && selectedOption === 'Asset') ||
      (item.Type === 'Device' && selectedOption === 'Device');
    const renderTitle = () => {
      const displayCode = item.DisplayCode ? setTranslation(item.DisplayCode) : '';
      const displayName = item.Name ? `(${setTranslation(item.Name)})` : '';
      if (isMatchingType) {
        return (
          <div className="item-row">
            <Checkbox
              key={item.Id}
              onClick={() => getTextOnChange(item)}
              checked={
                checkedArray &&
                Array.isArray(checkedArray) &&
                checkedArray.some((checkedItem) => checkedItem === item.Code)
              }
              value={item.Code}
            />
            <span onClick={() => getTextOnChange(item)}>
              {`${displayCode} ${displayName}`}
            </span>
          </div>
        );
      }
      return <span>{`${displayCode} ${displayName}`}</span>;
    };
    if (hasChildren && item.Type === 'Device' && selectedOption === 'Device') {
      return (
        <TreeNode title={renderTitle()} key={item.Id} dataRef={item}>
          {renderTreeNodes(item.children)}
        </TreeNode>
      );
    }
    return (
      <TreeNode key={item.Id} title={renderTitle()} dataRef={item}>
        {hasChildren && renderTreeNodes(item.children)}
      </TreeNode>
    );
  });
};
const setTranslation = (keyword) => {
  let { translationCache } = props;
  return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
};
// const onExpand = (expandedKeys) => {
//   setExpandedKeys(expandedKeys);
//   // setAutoExpandParent(false);
// };
return (
  <div
    style={{
      borderRight: '1px dashed white',
      width: '100%',
      flex: '35%',
      overflowY: 'auto',
      height: window.innerHeight - 250
    }}
  >
    <Tree
      className="hierarchyTree"
      style={{ color: 'white', backgroundColor: '#1a3652' }}      
      showLine
      checkedKeys={checkedArray}
      defaultExpandAll={true}
      switcherIcon={<DownOutlined />}
    >
      {renderTreeNodes(treeData)}
    </Tree>
  </div>
);
};
export default HierarchyModal;